import React, { Component } from 'react';
import './Home.css';

class Home extends Component {
    render() {
        return (
            <div className="home-container">
                <div className="container">
                    <div className="graf-bg-container">
                        <div className="graf-layout">
                            {/*<div className="graf-circle"></div>*/}
                            {/*<div className="graf-circle"></div>*/}
                            {/*<div className="graf-circle"></div>*/}
                            {/*<div className="graf-circle"></div>*/}
                            {/*<div className="graf-circle"></div>*/}
                            {/*<div className="graf-circle"></div>*/}
                            {/*<div className="graf-circle"></div>*/}
                            {/*<div className="graf-circle"></div>*/}
                            {/*<div className="graf-circle"></div>*/}
                            {/*<div className="graf-circle"></div>*/}
                            {/*<div className="graf-circle"></div>*/}
                        </div>
                    </div>
                    <h1 className="home-title"></h1>
                </div>
            </div>
        )
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/home/Home.js